import { fetchJSON } from "lib/fetch";
import siteConfig from "site-config";
import { IFetchMembersInMerhantRequest, IListMembersRequest } from "../types/merchants";
import { stringify } from "query-string";
import isEmpty from "lodash/isEmpty";

export interface IMerchantsService {
    fetchtUserMemberships: (
        userId: string,
        params?: IListMembersRequest
    ) => Promise<nuorder.merchant.v1.ListMembersResponse>;
    fetchMerchantsSharingWithMe: (
        merchantId: string,
        memberId: string,
        params?: nuorder.merchant.v1.IMerchantsSharingWithMeRequest
    ) => Promise<nuorder.merchant.v1.IMerchantsSharingWithMeResponse>;
    fetchtMerchantMembers: (
        merchantId: string,
        params?: IFetchMembersInMerhantRequest
    ) => Promise<nuorder.merchant.v1.ListMembersResponse>;
    fetch: (params?: nuorder.merchant.v1.ListMerchantsRequest) => Promise<nuorder.merchant.v1.ListMerchantsResponse>;
    fetchtFetchMerchantBrandPortals: (merchantBrandPortalId: string) => Promise<nuorder.merchant.v1.BrandPortal>;
    fetchMembershipByUserId: (merchantBrandPortalId: string, userId: string) => Promise<nuorder.merchant.v1.Member>;
}

export const merchants: IMerchantsService = {
    fetchtUserMemberships: (userId: string, params = {}) =>
        fetchJSON(`${siteConfig.goAPI}/v1/users/${userId}/memberships?${stringify(params)}`),
    fetchMerchantsSharingWithMe: (
        merchantId: string,
        memberId: string,
        params: nuorder.merchant.v1.IMerchantsSharingWithMeRequest
    ) =>
        fetchJSON(
            `${siteConfig.goAPI}/v1/merchants/${merchantId}/members/${memberId}/space/merchantsSharingToMember${
                !isEmpty(params) ? `?${stringify(params)}` : ""
            }`
        ),
    fetchtMerchantMembers: (merchantId: string, params?: IFetchMembersInMerhantRequest) =>
        fetchJSON(
            `${siteConfig.goAPI}/v1/merchants/${merchantId}/members${!isEmpty(params) ? `?${stringify(params)}` : ""}`
        ),
    fetch: (params = {}) => fetchJSON(`${siteConfig.goAPI}/v1/merchants?${stringify(params)}`),
    fetchtFetchMerchantBrandPortals: (merchantBrandPortalId: string) =>
        fetchJSON(`${siteConfig.goAPI}/v1/merchant_brand_portals/${merchantBrandPortalId}`),
    fetchMembershipByUserId: (merchantId: string, userId: string) =>
        fetchJSON(
            `${siteConfig.goAPI}/v1/merchants/${merchantId}/get_member_by_user_id?${stringify({ user_id: userId })}`,
            {
                method: "POST",
            }
        ),
};
